export default "__VITE_ASSET__DPD4kc5y__"